import { Component, computed, Input, ChangeDetectionStrategy } from '@angular/core';
import { CandidateModel } from '@shared/models';

@Component({
  selector:      'candidate-card',
  templateUrl: './candidate-card.component.html',
  host: { class: 'am-flex-1 border-radius-wide' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CandidateCardComponent {
  @Input({ required: true }) item: CandidateModel;
  @Input() loading: boolean = false;

  jobs = computed(() => this.item?.jobs?.map(it => it.label).join('; ').trim());
  constructor() {}

  candidatePhoto(): string {
    switch (this.item?.gender) {
      case 'm': { return 'assets/images/avatar-male.svg';   };
      case 'w': { return 'assets/images/avatar-female.svg'; };
      default:  { return 'assets/images/avatar.svg';        };
    };
  }

  getAvailabilityIcon(): string {
    if (!this.item?.available_from) return 'icon-event-busy ';
    else                            return 'icon-event-limited';
  }

  getAvailabilityLabel(): string {
    if     (!this.item?.available_from)                                              return 'Nicht verfügbar';
    else if (this.item?.available_from === (new Date()).toISOString().split('T')[0]) return 'ab: sofort';
    else                                                                             return `ab: ${this.item.available_from}`;
  }

}
